import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CustomerPaymentPage } from '../../../../components/MfeParcels/CustomerPaymentPage'
import { useEvents } from '../../../../utilities/hooks/useEvents'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

const _PaymentSettings: React.FC<Props> = (props) => {
  useEvents(props)

  return <CustomerPaymentPage />
}

export const PaymentSettings = inject('currentCompanyStore')(observer(_PaymentSettings))
